import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from "@angular/material/legacy-autocomplete";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { WpayAutoCompleteComponent } from "./wpay-auto-complete.component";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { IconModule } from "@shared/components/icon/icon.module";
import { MatLegacyProgressBarModule as MatProgressBarModule } from "@angular/material/legacy-progress-bar";

@NgModule({
	declarations: [WpayAutoCompleteComponent],
	imports: [
		CommonModule,
		MatFormFieldModule,
		FormsModule,
		ReactiveFormsModule,
		MatTooltipModule,
		MatInputModule,
		MatIconModule,
		MatAutocompleteModule,
		MatCheckboxModule,
		IconModule,
		MatProgressBarModule
	],
	exports: [WpayAutoCompleteComponent]
})
export class WpayAutoCompleteModule {}
